import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
export const workFlowGridColumnsMaster = () => [
    {
        field: 'project',
        headerName: 'Project',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        flex: 2
    },
    {
        field: 'workflow',
        headerName: 'Workflow',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        cellRenderer: 'agGroupCellRenderer',
        flex: 2,
    },
    {
        field: 'transitions',
        headerName: 'Transitions',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        flex: 1
    },
    {
        field: 'unused_transitions',
        headerName: 'Unused Transitions',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        flex: 1
    },
    {
        field: 'issues_within',
        headerName: apiProvider.getEntityUpper() + 's within workflow',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        headerTooltip: "# issues where the transitions are all part of the workflow",
        valueFormatter: ({ value }) => numberWithCommas(value),
        
    },
    {
        field: 'perc_issues_within',
        headerName: '% ' + apiProvider.getEntityUpper() + 's within workflow',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        headerTooltip: "% " + apiProvider.getEntityUpper() + "s where transitions are all part of the workflow",
        valueFormatter: ({ value }) => formatPercentage(value,1),
    },
    {
        field: 'variants_within',
        headerName: 'Variants within workflow',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        headerTooltip: "# variants where the transitions are all part of the workflow",
        valueFormatter: ({ value }) => numberWithCommas(value),
    },
    {
        field: 'perc_variants_within',
        headerName: '% variants within workflow',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        headerTooltip: "% variants where transitions are all part of the workflow",
        valueFormatter: ({ value }) => formatPercentage(value,1),
    },
    {
        field: 'matching_issues',
        hide: true
    },
    {
        field: 'matching_variants',
        hide: true
    },
    {
        field: 'nodeDataArray',
        hide: true
    },
    {
        field: 'nodeLinkArray',
        hide: true
    },

];

export function numberWithCommas(x) {
    if (x === -1 || x === undefined) return ''
    return Number(x).toLocaleString()
}

export function formatPercentage(x, decimals) {
    if (x === -1) return ''
    else return (x * 100).toFixed(decimals) + '%';
}